import { ACTION_TYPES } from "../../actions/indirects/IndirectActions"

const initialState = {
    CountDasboard: [],
    IndirectListByStatus: [],
    BranchOfficeList: [],

    //Invoices
    resultInvoice: {},
    historyList: [],
    orderDetail: {},
    listRejectedInvoices: [],
    //Complement
    resultComplement: {},
    listInvoicesComplement: {}
}
export const IndirectReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                CountDasboard: [],
                IndirectListByStatus: [],
                BranchOfficeList: [],
                //Invoices
                resultInvoice: {},
                historyList: [],
                orderDetail: {},
                listRejectedInvoices: [],
                //Complement
                resultComplement: {},
                listInvoicesComplement: {}
            }
        case ACTION_TYPES.FETCH_INDIRECT_DASHBOARD:
            return {
                ...state,
                CountDasboard: [...action.payload]
            }
        case ACTION_TYPES.FETCH_INDIRECT_LIST:
            return {
                ...state,
                IndirectListByStatus: [...action.payload]
            }
        case ACTION_TYPES.FETCH_BRANCH_OFFICE_LIST:
            return {
                ...state,
                BranchOfficeList: [...action.payload]
            }


        //Invoices
        case ACTION_TYPES.RESULT_UPLOAD_INVOICE:
            return {
                ...state,
                resultInvoice: action.payload
            }
        case ACTION_TYPES.FETCH_INVOICE_HISTORY:
            return {
                ...state,
                historyList: [...action.payload]
            }
        case ACTION_TYPES.FETCH_ORDER_DETAIL_INDIRECT:
            return {
                ...state,
                orderDetail: action.payload
            }
        case ACTION_TYPES.FETCH_REJECTED_INVOICE:
            return {
                ...state,
                listRejectedInvoices: [...action.payload]
            }


        //Complements
        case ACTION_TYPES.RESULT_UPLOAD_COMPLEMENT:
            return {
                ...state,
                resultComplement: action.payload
            }
        case ACTION_TYPES.FETCH_INVOICE_COMPLEMENT:
            return {
                ...state,
                listInvoicesComplement: action.payload
            }
        default:
            return state
    }
}

